import React from "react";
import { Table } from "reactstrap";

/**
 * İptal ve iade koşullarını (kademeli iptal ücretlerini) tablo halinde gösterir.
 * Kullanıcının görevine uygulanacak kademe vurgulanır; böylece kullanıcı iptal
 * onayından önce hangi koşula tabi olduğunu açıkça görür.
 *
 * @param {Array}  policies        - fetchCancelPolicies() çıktısı (Advert_Pricing satırları)
 * @param {number} diffDays        - Göreve kalan gün sayısı
 * @param {number|null} activePricingId - calcCancelFee'den dönen pricingId (vurgulanacak satır)
 */
const CancelPolicyTable = ({ policies = [], diffDays, activePricingId }) => {
  if (!policies.length) return null;

  const sorted = [...policies].sort(
    (a, b) => a.Cancel_Days_Limit - b.Cancel_Days_Limit
  );
  const maxLimit = sorted[sorted.length - 1]?.Cancel_Days_Limit ?? 0;
  // Hiçbir kademe eşleşmiyorsa ücretsiz iptal kademesi aktiftir.
  const isFree = !sorted.some((p) => diffDays <= p.Cancel_Days_Limit);

  return (
    <div className="mt-3 text-start">
      <h6 className="fw-bold mb-2">
        <i className="mdi mdi-information-outline me-1 text-primary"></i>
        İptal ve İade Koşulları
      </h6>
      <Table bordered size="sm" className="mb-2 align-middle">
        <thead className="table-light">
          <tr>
            <th>Göreve Kalan Süre</th>
            <th className="text-end">İptal Ücreti</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((p) => {
            const isActive = !isFree && p.ID === activePricingId;
            const label =
              p.Cancel_Days_Limit === 0
                ? "Aynı gün iptal"
                : `Son ${p.Cancel_Days_Limit} gün içinde iptal`;
            return (
              <tr key={p.ID} className={isActive ? "table-warning fw-bold" : ""}>
                <td>
                  {label}
                  {isActive && (
                    <span className="badge bg-warning text-dark ms-2">
                      Sizin durumunuz
                    </span>
                  )}
                </td>
                <td className="text-end">{p.Price} TL</td>
              </tr>
            );
          })}
          <tr className={isFree ? "table-success fw-bold" : ""}>
            <td>
              {maxLimit + 1} gün ve öncesi iptal
              {isFree && (
                <span className="badge bg-success ms-2">Sizin durumunuz</span>
              )}
            </td>
            <td className="text-end">Ücretsiz</td>
          </tr>
        </tbody>
      </Table>
      <small className="text-muted">
        Görev başlangıcına {diffDays} gün kaldı. Yukarıda işaretli kademe sizin
        iptalinize uygulanır.
      </small>
    </div>
  );
};

export default CancelPolicyTable;
